export default __webpack_public_path__ + "static/media/Artboard 12.7003c56e.png";